const multiplier = 10;

const player = document.getElementById('player');
const player_source = document.getElementById('player-source');
function pauseAllTracks(){
    const play_buttons = document.getElementsByClassName('play-button');
    for (let i=0; i<play_buttons.length; ++i){
      const play_button = play_buttons[i];
      stopTrack(play_button);
    }
}
function stopTrack(play_button){
    if (play_button.classList.contains('playing')){
      play_button.classList.remove('playing');
      play_button.innerHTML = '▶&#xFE0E;';
      getAudioFromPlay(play_button).pause();
    }
}
function getSeekFromAudio(audio){
  return audio.parentNode.getElementsByClassName('alm-audio-slider')[0];
}
function getSeekFromPlay(play_button){
  return play_button.parentNode.getElementsByClassName('alm-audio-slider')[0];
}
function getAudioFromPlay(play_button){
 return play_button.parentNode.getElementsByClassName('alm-audio-player')[0];
}
function getPlayFromAudio(audio){
 return audio.parentNode.getElementsByClassName('play-button')[0];
}
function getRemainingFromSeek(seek_slider){
  return seek_slider.parentNode.getElementsByClassName('alm-audio-clip-remaining')[0];
}
function processPlay(event){
    const play_button = event.target;
    if (play_button.classList.contains('playing')){
      stopTrack(play_button);
    } else {
      pauseAllTracks();
      play_button.classList.add('playing');
      play_button.innerText = '⏸︎';
      const seek_slider = getSeekFromPlay(play_button)
      const audio = getAudioFromPlay(play_button);
      if (seek_slider.value == seek_slider.max){
        seek_slider.value = 0;
        audio.currentTime = 0;
      }
      audio.play();
    }
}
function checkIfEnd(audio, seek_slider){
  if (seek_slider.value == seek_slider.max){
    const play_button = getPlayFromAudio(audio)
    stopTrack(play_button);
  }
}
function updateRemaining(seek_slider){
  const total_secs = Math.floor((seek_slider.max - seek_slider.value) / multiplier);
  const remainder_secs = String(total_secs % 60).padStart(2, '0');
  const mins = String(Math.floor(total_secs / 60)).padStart(1, '0');
  getRemainingFromSeek(seek_slider).innerText = mins + ':' + remainder_secs;
}
function initialiseSeekSlider(audio){
  if (event instanceof Event){
    audio = event.target; 
  }
  const seek_slider = getSeekFromAudio(audio)
  seek_slider.max = Math.floor(audio.duration) * multiplier;
  updateRemaining(seek_slider);
  seek_slider.addEventListener('change', () => {
    audio.currentTime = seek_slider.value / multiplier;
    updateRemaining(seek_slider)
    checkIfEnd(audio, seek_slider);
  });
  audio.addEventListener('timeupdate', () => {
    seek_slider.value = audio.currentTime * multiplier;
    updateRemaining(seek_slider)
    checkIfEnd(audio, seek_slider);
  });
}
function initialiseTrackButtons(){
  const audios = document.getElementsByClassName('alm-audio-player');
  for (let i=0; i<audios.length; ++i){
    const audio = audios[i];
    if (audio.readyState > 0) {
      initialiseSeekSlider(audio);
    } else {
      audio.addEventListener('loadedmetadata', initialiseSeekSlider);
    }
    const play_button = audio.parentNode.getElementsByClassName('play-button')[0];
    play_button.addEventListener('click', processPlay);
  }
}
initialiseTrackButtons();